import { useDeviceType } from "@dash/mq";
import { MdEdit, MdMoreVert } from "react-icons/md";
import { Link } from "react-router-dom-v5-compat";

import { PinnedLink } from "@megaron/docs-contracts";

import { navAccent } from "../nav/navConstants";
import { NavPinnedRowActionButton, navPinnedRowBarCss, navPinnedRowLabelCss } from "./navPinnedRowStyles";
import { isPinnedLinkExternal, pinnedLinkColor, pinnedLinkHref } from "./pinnedLinkHelpers";

type Props = {
  pin: PinnedLink;
  isActive?: boolean;
  onEdit: () => void;
  onNavigate?: () => void;
};

export const NavPinnedLinkRow: React.FC<Props> = ({ pin, isActive, onEdit, onNavigate }) => {
  const { isDesktop } = useDeviceType();

  const accentColor = pinnedLinkColor(pin.uri);
  const href = pinnedLinkHref(pin.uri);
  const isExternal = isPinnedLinkExternal(pin.uri);

  const rowCss = {
    display: "flex",
    alignItems: "center",
    gap: "0.625rem",
    padding: "0.1875rem 0",
    minWidth: 0,
    flex: 1,
    textDecoration: "none",
    color: navAccent,
    "&:hover": { opacity: 0.85 },
  };

  const content = (
    <>
      <span css={navPinnedRowBarCss(accentColor, isActive ? 1 : 0.55)} />
      <span css={navPinnedRowLabelCss(isActive)}>{pin.name}</span>
    </>
  );

  return (
    <div
      css={{
        display: "flex",
        alignItems: "center",
        gap: "0.375rem",
        minWidth: 0,
        "&:hover .pinned-link-edit": { opacity: 0.7 },
      }}
    >
      {isExternal ? (
        <a href={href} target="_blank" rel="noreferrer" onClick={onNavigate} title={pin.name} css={rowCss}>
          {content}
        </a>
      ) : (
        <Link to={href} onClick={onNavigate} title={pin.name} css={rowCss}>
          {content}
        </Link>
      )}

      <NavPinnedRowActionButton
        title="Edytuj"
        onClick={onEdit}
        className="pinned-link-edit"
        isHoverReveal={isDesktop}
      >
        {isDesktop ? <MdEdit /> : <MdMoreVert css={{ fontSize: "1.125rem" }} />}
      </NavPinnedRowActionButton>
    </div>
  );
};
